import { RouterErrorPage } from '@wellesley/error-kit'
import { Outlet, RouterProvider } from 'react-router-dom'
import { HostRouteObserver } from '@wellesley/host-remote'
import { MainLayout } from '../layouts/MainLayout'
import { hostRoutes } from './routes/hostRoutes'
import { getAppsRoutes } from './routes/appsRoutes'
import { ProtectPrivateServer } from '@wellesley/auth'
import { createRouter } from './helpers/createRouter'

const { router } = createRouter([
  {
    element: (
      <>
        <HostRouteObserver />
        <ProtectPrivateServer>
          <MainLayout>
            <Outlet />
          </MainLayout>
        </ProtectPrivateServer>
      </>
    ),
    errorElement: <RouterErrorPage />,
    children: [...hostRoutes, getAppsRoutes()],
  },
])

export const Router = () => {
  return <RouterProvider router={router} />
}
